export default __webpack_public_path__ + "static/media/notification.48dfe1c2.mp3";